import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "green-bottomArrow",
  "use": "green-bottomArrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"green-bottomArrow\"><path d=\"M194.56 352.768 512 671.232l317.44-318.464L512 521.728z\" fill=\"#00FFBE\" /><path d=\"M194.56 352.768 512 521.728l317.44-168.96L512 521.728z\" fill=\"#00FFBE\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol